// Support body component for the support page.

import Description from './supportDescription';
import Header from './supportHeader';

/**
 * Support body component for the support page.
 * Composes the header and the description sections.
 *
 * @returns {JSX.Element} Support body component
 */
export default function SupportBody() {
  return (
    <>
      <Header />
      <Description />
    </>
  );
}
